// extracted by mini-css-extract-plugin
export default {"commonWrapper":"LayoutSelector_commonWrapper__FYUN7","layoutWrapper":"LayoutSelector_layoutWrapper__o3SDc","layoutName":"LayoutSelector_layoutName__GaMPx"};